import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  appAutocomplete: {
    '& .MuiInputBase-root': {
      height: '44px',
      minHeight: '44px',
    },

    '& .MuiButtonBase-root': {
      margin: '3px 0',
      height: '30px',
    },
    '& .MuiOutlinedInput-root': {
      padding: '0 40px 0 0 !important',
      border: 'none !important',
      '& input': {
        padding: '8px',
      },
    },
    '& .MuiAutocomplete-endAdornment': {
      top: '0',
    },
  },
}));
